import React from 'react'
import { CMSSection } from '@/services/CMS/types'
import { renderBlocks } from '@/services/CMS/components/RenderBlocks'
import './Section.scss'

export const Section = React.memo(({ richText }: CMSSection) => {
  return <section className="cms-section">{renderBlocks(richText)}</section>
})
